import { render, staticRenderFns } from "./folder-table.vue?vue&type=template&id=3d5a0130&scoped=true&"
import script from "./folder-table.vue?vue&type=script&lang=js&"
export * from "./folder-table.vue?vue&type=script&lang=js&"
import style0 from "./folder-table.vue?vue&type=style&index=0&id=3d5a0130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5a0130",
  null
  
)

export default component.exports